import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Carte from "@/components/site/Carte";
import PhoneBar from "@/components/site/PhoneBar";
import Horaires from "@/components/site/Horaires";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div>
      <div className="grain-overlay" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Carte />
        <PhoneBar />
        <Horaires />
      </main>
      <Footer />
    </div>
  );
}
